import React from 'react';
import { Lottie } from '../Lottie';
import './HowItWorks.scss';
import mapAnimation from '../../lottie/map.json';
import redeemAnimation from '../../lottie/redeem.json';
import eatAnimation from '../../lottie/pizza.json';

const graphicSet = {
  Map: mapAnimation,
  'Go to Voucher UI': redeemAnimation,
  Logo: eatAnimation,
};

const iconClass = {
  Map: 'map',
  'Go to Voucher UI': 'ticket',
  Logo: 'eat',
};

const Column = ({ tagline, title, content, graphic }) => (
  <div className="how-it-works-column">
    <Lottie animationData={graphicSet[graphic]} container={`${iconClass[graphic]}-lottie`} />
    <div className="how-it-works-column-body">
      {tagline ? <span className={`how-it-works-column-tagline ${iconClass[graphic]}`}>{tagline.text}</span> : null}
      {title ? <h4 className="how-it-works-column-title">{title.text}</h4> : null}
      {content ? (
        <div className="how-it-works-column-content" dangerouslySetInnerHTML={{ __html: content.html }} />
      ) : null}
    </div>
  </div>
);

export const HowItWorks = ({ title, columns }) => {
  if (!title || !columns || columns.length < 1) return null;
  return (
    <section className="how-it-works">
      <div className="wrapper">
        <h2 className="how-it-works-title">{title.text}</h2>
        <div className="how-it-works-columns">
          {columns.map((column, index) => (
            <Column key={column.tagline ? column.tagline.text : column.graphic} {...column} />
          ))}
        </div>
      </div>
    </section>
  );
};
